import React from 'react';
import './SidebarTranslation.css'
import {SidebarTranslationOrdersList} from "./orders-list/SidebarTranslationOrdersList";
import {groupBy} from "lodash/collection";
import {createOrderItem} from "../utils";


const SidebarTranslationInProgress = ({ orderList }) => {
    let orders = groupBy(orderList, 'id_order_group');
    orders = Object.entries(orders).map(createOrderItem);
    return (
        <div className="entry min-h-300 max-h-310">
            <SidebarTranslationOrdersList orders={orders} />
        </div>
    );
}


export default SidebarTranslationInProgress